/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：989
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.StreamReader = exports.EndOfStreamError = undefined
var r = require(/* 1162 */"./1162/index")
Object.defineProperty(exports, "EndOfStreamError", {
  enumerable: true,
  get: function () {
    return r.EndOfStreamError
  }
})
var i = require(/* 2397 */"./2397/index")
Object.defineProperty(exports, "StreamReader", {
  enumerable: true,
  get: function () {
    return i.StreamReader
  }
})
